export class Permissions {
	public static ACCOUNTING_BILLLOAD = 'accounting:billload';
	public static ACCOUNTING_EDIVARIANCES = 'accounting:edivariances';
	public static ACCOUNTING_INVOICELOAD = 'accounting:invoiceload';
	public static ACCOUNTING_MANAGERATES = 'accounting:managerates';
	public static ACCOUNTING_UPDATECARRIERCOST = 'accounting:updatecarriercost';
	public static ACCOUNTING_UPDATECUSTOMERCOST = 'accounting:updatecustomercost';
	public static ACCOUNTING_UPSIMPORT = 'accounting:upsimport';
	public static ACCOUNTING_VIEWINVOICES = 'accounting:viewinvoices';
	public static ACCOUNTING_VIEWRATES = 'accounting:viewrates';
	public static ADMIN_INVOICEIMPORT = 'admin:invoiceimport';
	public static CARRIERACCOUNTS_MANAGE = 'carrieraccounts:manage';
	public static CARRIERACCOUNTS_VIEW = 'carrieraccounts:view';
	public static CARRIERS_MANAGE = 'carriers:manage';
	public static CARRIERS_PREPRO = 'carriers:prepro';
	public static CLAIMS_MANAGE = 'claims:manage';
	public static COMPLIANCE_MANAGE = 'compliance:manage';
	public static CUSTOMERGROUPS_MANAGE = 'customer-groups:manage';
	public static CUSTOMERS_MANAGE = 'customers:manage';
	public static CUSTOMERS_VIEWINVOICES = 'customers:viewinvoices';
	public static DEV_ALL = 'dev:all';
	public static EXTERNALAPI_READ = 'externalapi:read';
	public static NMFCS_MANAGE = 'nmfcs:manage';
	public static OTHER_ASSETINVENTORY = 'other:assetinventory';
	public static REPORTS_AUTOQUOTE = 'reports:autoquote';
	public static REPORTS_VIEW = 'reports:view';
	public static SHIPMENTS_CHECKCALLS = 'shipments:checkcalls';
	public static SHIPMENTS_CREATE = 'shipments:create';
	public static SHIPMENTS_CREATEDATLOAD = 'shipments:createdatload';
	public static SHIPMENTS_DELETENOTES = 'shipments:deletenotes';
	public static SHIPMENTS_DONOTUSEOVERRIDE = 'shipments:donotuseoverride';
	public static SHIPMENTS_EDITCUSTOMER = 'shipments:editcustomer';
	public static SHIPMENTS_IMPORT = 'shipments:import';
	public static SHIPMENTS_IMPORTCUSTOM = 'shipments:importcustom';
	public static SHIPMENTS_MANAGEERRATES = 'shipments:manageerrates';
	public static SHIPMENTS_MULTIQUOTE = 'shipments:multiquote';
	public static SHIPMENTS_OVERRIDECALCULATEDCOSTS = 'shipments:overridecalculatedcosts';
	public static SHIPMENTS_OVERRIDECUSTOMERCOST = 'shipments:overridecustomercost';
	public static SHIPMENTS_OVERRIDEMWTP = 'shipments:overridemwtp';
	public static SHIPMENTS_QUICKQUOTE = 'shipments:quickquote';
	public static SHIPMENTS_ZIPQUOTE = 'shipments:zipquote';
	public static SMARTINBOX_READ = 'smartinbox:read';
	public static USERS_MANAGEALL = 'users:manageall';
	public static USERS_MANAGEEXTERNAL = 'users:manageexternal';
	public static VENDOR_MANAGE = 'vendor:manage';
	public static readonly VENDOR_PUSHTONETSUITE = 'vendor:pushtonetsuite';
	public static VENDOR_VIEW = 'vendor:view';
}
